
import React from 'react';
import {Action, DashboardContainer, TextLoading} from "../../funcs/utils";
import {
  date_to_EST,
  elapsed_sec_to_dd_hhmmss,
  timestamp_sec_to_mmddyy_hhmmss,
  timestamp_str_to_mmddyy_hhmmss,
} from "../../../lib/time";
import ReactTable from "react-table";
import {centsToString} from "../../../lib/currency-utils";
import "./styles.scss";
import {adminLookupBalances} from "../../superadmin/payments-reducer";
import {SplitUsername} from "../../../lib/constants";
import {DashboardTable} from "../dashboard-table";


const STYLE_LUT = (num_rows) => {
  return [
    // Vertical lines
    {
      pred: () => true,
      style: {
        borderLeft: "solid 1px black",
        borderRight: "solid 1px black",
        paddingLeft: "0.3rem",
      }
    },
    // Header top/bottom borders
    {
      pred: (row) => row === 0,
      style: {
        borderTop: "solid 1px black",
        borderBottom: "solid 1px black",
      }
    },
    {
      pred: (row) => row > 0 && row % 2,
      style: {
        backgroundColor: "#EEE",
      }
    },
    {
      pred: (row) => row === num_rows - 1,
      style: {
        borderBottom: "solid 1px black",
      }
    }
  ]
}

const TABLE_STYLE = {
  width: "100%",
  tableLayout: "auto",
}

class SAPayments extends React.Component {

  constructor() {
    super();
    this.state = {
      execute_query: false,
    }
  }

  componentDidMount = () => {
    if (this.payments_empty()) {
      this.load_payments();
    }
  }

  payments_empty = () => {
    const props = ["past", "current", "future", "queued", "future_missed"];
    let empty = true;
    props.forEach(prop => {
      if (Object.keys(this.props.payments[prop]).length > 0) {
        empty = false;
      }
    });
    return empty;
  }

  load_payments = () => {
    this.props.loadPayments();
  }

  execute_query = () => {
    this.setState({
      execute_query: true,
    });
    adminLookupBalances(this.props.token).then(() => {
        this.setState({
          execute_query: false,
        });
        this.load_payments();
      })
  }
  
  renderQuery = () => {

    let query_time;

    if (this.props.payments.timestamp) {
      const time_str = timestamp_sec_to_mmddyy_hhmmss(
        this.props.payments.timestamp);
      query_time = (
        <div style={{paddingTop: "1rem"}}>
          <span>Last Query {time_str}</span>
        </div>
      );
    }

    return (
      <div align={"center"}>
        <Action onClick={this.execute_query}>
          <TextLoading
            label={"Start Query"}
            loading={this.state.execute_query}/>
        </Action>
        { query_time }
      </div>
    )
  }

  renderCurrentTable = () => {
    const curr_items = this.props.payments.current;
    const cols = [
      "ID", "WLF", "Date (EST)", "From", "From Acct", "From Bank",
      "To Acct", "To Bank", "Amount", "Ach ID", "State"
    ];
    const data = [ cols ];
    curr_items.forEach(item => {
      const date = date_to_EST(new Date(item.timestamp_sec * 1000));
      const source_name = item.metadata.source
        ? item.metadata.source.name : "UNKNOWN";
      const source_bank_name = item.metadata.source
        ? item.metadata.source.bank_name : "UNKNOWN";
      const dest_name = item.metadata.destination
        ? item.metadata.destination.name : "UNKNOWN";
      const dest_bank_name = item.metadata.destination
        ? item.metadata.destination.bank_name : "UNKNOWN";
      data.push([
        item.id,
        item.wlf_id,
        timestamp_str_to_mmddyy_hhmmss(date),
        SplitUsername(item.metadata.from.username).email,
        source_name,
        source_bank_name,
        dest_name,
        dest_bank_name,
        centsToString(item.metadata.amt_cents),
        item.metadata.ach_id,
        item.metadata.transfer_state,
      ])
    })
    const container_div = {
      overflowX: "auto",
    }
    return (
      <div style={container_div}>
        <DashboardTable
          tdStyleLut={STYLE_LUT(data.length)}
          tableStyle={TABLE_STYLE}
          data={data}
          />
      </div>
    )
  }

  renderBalanceTable = () => {
    const items = this.props.payments.balance;
    const cols = [
      "WLF", "Queried (EST)", "Name", "Balance", "Total",
    ]
    const data = [ cols ];
    items.forEach(item => {
      const date = date_to_EST(new Date(item.balance.updated_sec * 1000));
      data.push([
        item.wlf_id,
        timestamp_sec_to_mmddyy_hhmmss(date.getTime() / 1000),
        item.name,
        centsToString(item.balance.balance_cents),
        centsToString(item.balance.total_cents),
      ])
    })

    return (
      <DashboardTable
        tdStyleLut={STYLE_LUT(data.length)}
        tableStyle={TABLE_STYLE}
        data={data}/>);
  }

  renderPastTable = () => {
    const items = this.props.payments.past;
    const cols = [
      "WLF", "Requested (EST)", "Completed (EST)", "Elapsed",
      "From", "From Account", "From Bank",
      "To", "To Account", "To Bank", "Amount", "Ach ID", "State"
    ];
    const data = [ cols ];
    items.forEach(item => {
      const req_date = date_to_EST(new Date(item.requested * 1000));
      const closed_date = date_to_EST(new Date(item.closed_timestamp_sec * 1000));
      const elapsed_sec = Math.floor((closed_date.getTime() - req_date.getTime()) / 1000);
      data.push([
        item.wlf_id,
        timestamp_str_to_mmddyy_hhmmss(req_date),
        timestamp_str_to_mmddyy_hhmmss(closed_date),
        elapsed_sec_to_dd_hhmmss(elapsed_sec),
        SplitUsername(item.metadata.from.username).email,
        item.metadata.source.name,
        item.metadata.source.bank_name,
        SplitUsername(item.metadata.to.username).email,
        item.metadata.destination.name,
        item.metadata.destination.bank_name,
        centsToString(item.metadata.amt_cents),
        item.metadata.ach_id,
        item.metadata.transfer_state,
      ])
    })
    const container_style = {
      overflowX: "auto",
    }
    return (
      <div style={container_style}>
        <DashboardTable
          tdStyleLut={STYLE_LUT(data.length)}
          tableStyle={TABLE_STYLE}
          data={data}/>
      </div>);

  }

  renderTable = (items, columns) => {
    if (!items) {
      return null;
    }

    const container_style = {
      overflowX: "auto",
      whiteSpace: "nowrap",
    }
    return (
      <div style={container_style}>
        <div>
          <ReactTable
            data={items}
            pageSize={items.length}
            showPagination={false}
            className="-striped -highlight"
            columns={columns}
            />
        </div>
      </div>
    )
  }

  render = () => {

    const client = this.props.client;
    const loading = this.props.payments.loading;

    return (
      <div className={"img-col"} id={"sa_payments"}>
        <DashboardContainer
          client={client}>
          { this.renderQuery() }
        </DashboardContainer>
        <DashboardContainer
          title={"Current"}
          spinner={loading}
          client={client}>
          { this.renderCurrentTable() }
        </DashboardContainer>
        <DashboardContainer
          title={"Balance Accounts"}
          spinner={loading}
          client={client}>
          { this.renderBalanceTable() }
        </DashboardContainer>
        <DashboardContainer
          title={"Past"}
          spinner={loading}
          client={client}>
          { this.renderPastTable() }
        </DashboardContainer>
        { /* <DashboardContainer
          title={"Future"}
          spinner={loading}
          client={client}>
          { this.renderTable(
            NEW_PAYMENT_STACK
              ? this.props.payments.future
              : this.props.payments.future.items,
            FUTURE_COLUMNS) }
        </DashboardContainer>
        <DashboardContainer
          title={"Future Missed"}
          spinner={loading}
          client={client}>
          { this.renderTable(
            NEW_PAYMENT_STACK
            ? [] : this.props.payments.future_missed.items,
            FUTURE_COLUMNS) }
        </DashboardContainer> */ }
      </div>

    )
  }
}

export { SAPayments };
